/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsticketvoid2Inputs */

const en_ticketsticketvoid2 = /** @type {(inputs: Ticketsticketvoid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Void`)
};

const de_ticketsticketvoid2 = /** @type {(inputs: Ticketsticketvoid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültig`)
};

/**
* | output |
* | --- |
* | "Void" |
*
* @param {Ticketsticketvoid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsticketvoid2 = /** @type {((inputs?: Ticketsticketvoid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsticketvoid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsticketvoid2(inputs)
	return de_ticketsticketvoid2(inputs)
});
export { ticketsticketvoid2 as "ticketsTicketVoid" }